import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import Modal from 'components/Modal';
import { Colors } from 'theme';

const ModalContainer = styled(Modal)(({ theme }) => ({
  minHeight: '48.4rem',
  [theme.breakpoints.down('sm')]: {
    minHeight: 0,
  },
}));

const ModalTitle = styled(Typography)({
  fontSize: '2rem',
  fontWeight: '600',
});

const CancelButton = styled(Button)(({ theme }) => ({
  marginRight: '4.5rem',
  fontSize: '1.4rem',
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  height: '4rem',
  width: '16rem',
  border: '0',
  color: `${Colors.white} !important`,
  backgroundColor: Colors.primaryLight,
  outline: 'none',
  margin: '0',
  marginLeft: '1rem',
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: Colors.white,
    textDecoration: 'none',
  },
  textTransform: 'uppercase',
  fontSize: '1.4rem',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: 0,
  },
}));

const EffectiveDateTitle = styled(Typography)({
  fontSize: '1.4rem',
  fontWeight: '600',
});

const NotAcceptingTermsTitle = styled(Typography)({
  marginBottom: '5.5rem',
});

const NextButton = styled(Button)({
  float: 'right',
});

const PreviousButton = styled(Button)({
  float: 'left',
});

const Pager = styled('ul')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1rem 0',
  margin: 0,
  '> li': {
    'list-style-type': 'none',
    margin: 0,
    padding: 0,
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'stretch',
    flexDirection: 'column',
    gap: '1rem',
  },
}));

export {
  ModalContainer,
  ModalTitle,
  CancelButton,
  SubmitButton,
  EffectiveDateTitle,
  NotAcceptingTermsTitle,
  NextButton,
  PreviousButton,
  Pager,
};
